"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = void 0;
// Generated by genversion.
exports.version = '1.1.0';
